<template>
  <section class="hero-pet-section">
    <img class="medal" src="@/assets/icon/medal-black.png" alt="hero pet medal">
    <h2>Be our Hero and save lives</h2>
    <h2>โฉมหน้าพี่ใหญ่ใจดี ที่มาร่วมเป็นฮีโร่กับเรา</h2>
    <hero-pet-panel class="hero-panel" :heroPets="heroPets" :showLoadMore="false"/>
    <div class="cta">
      <router-link :to="{ name: 'donation'}" class="btn btn-clear">ร่วมบริจากเลือด</router-link>
      <router-link :to="{ name: 'heroPet'}" class="btn btn-primary">ฮีโร่อื่นๆ</router-link>
    </div>
  </section>
</template>

<script>
import HeroPetPanel from '@/components/HeroPetPanel.vue'

export default {
  name: 'HeroPetSection',
  data () {
    return {
      heroPets: []
    }
  },
  // mounted () {
  //   this.$http.get('pet/list/').then((response) => {
  //     var heroPetsResult = this.shuffleArray(
  //       response.data.result.filter(hero => hero.blood_donations.length > 0)
  //     ).slice(0, 4)
  //     for (var hero of heroPetsResult) {
  //       var bloodGroup = hero.blood_group ? hero.blood_group : 'ไม่ระบุ'
  //       var medal
  //       if (hero.blood_donations.length >= 15) {
  //         medal = 'Gold'
  //       } else if (hero.blood_donations.length >= 8) {
  //         medal = 'Silver'
  //       } else if (hero.blood_donations.length >= 1) {
  //         medal = 'Bronze'
  //       }
  //       this.heroPets.push({
  //         id: hero.id,
  //         name: hero.name,
  //         image: hero.image,
  //         donations: hero.blood_donations.length,
  //         comments: hero.pet_comments.length,
  //         bloodGroup: bloodGroup,
  //         medal: medal
  //       })
  //     }
  //   })
  // },
  components: {
    HeroPetPanel
  }
}
</script>

<style scoped lang="scss">
.hero-pet-section {
  background-color: $gray-100;
  padding: 1.5rem 0;
  .medal {
    width: 2rem;
    margin: auto;
    display: block;
  }
  h2 {
    text-align: center;
    font-weight: $font-weight-light;
    font-size: $h4-font-size;
  }
  .hero-panel {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }
  .cta {
    text-align: center;
    a {
      margin: 0 0.5rem;
    }
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .hero-pet-section {
    padding: 2rem 0;
    h2 {
      font-size: $h3-font-size;
    }
    .hero-panel {
      margin-top: 2rem;
      margin-bottom: 1rem;
    }
  }
}
</style>
